
import axios from 'axios';

import {
  defineComponent,
  ref,
  reactive,
  onMounted,
  watch,
} from 'vue';

import {
  TRAFFIC_TYPES,
  TRAFFIC_TYPE_POP,
  TRAFFIC_TYPE_PUSH,
  TRAFFIC_CATEGORIES,
  DEVICE_TYPES,
} from '@/libs/consts';

export default defineComponent({
  setup() {
    const trafficTypes = [...TRAFFIC_TYPES].filter((type) => type.value === TRAFFIC_TYPE_POP || type.value === TRAFFIC_TYPE_PUSH);

    const filters = reactive({
      traffic_type: TRAFFIC_TYPE_POP,
      traffic_category: null,
      device_type: null,
    });

    const data = ref([]);

    const loading = ref(true);

    const fetchData = async (): Promise<void> => {
      try {
        const response = await axios.get('/api/v3/estimator', { params: filters });

        data.value = response.data;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      } finally {
        loading.value = false;
      }
    };

    onMounted(() => fetchData());

    watch(filters, () => {
      loading.value = true;

      fetchData();
    });

    return {
      TRAFFIC_CATEGORIES,
      DEVICE_TYPES,
      trafficTypes,
      filters,
      data,
      loading,
      fetchData,
    };
  },
});
